angular.module('rjmNg.services').factory 'dataWarehouseTablePath', [
  "$rootScope"
  "$route"
  "$location"
  "appRoute"
  ($rootScope, $route, $location, appRoute) ->

    basePath = appRoute("/settings/data-warehouse/")

    tablePathService =

      generateTablePath: (tableId) ->
        if tableId? and +tableId isnt 0
          basePath + "table/#{tableId}"
        else
          basePath

      updateTablePath: (tableId = null) ->
        path = @generateTablePath tableId
        lastRoute = $route.current
        onDWPage = true
        un = $rootScope.$on "$locationChangeSuccess", () ->
          if onDWPage and $location.path().match(/data-warehouse.*/)
            $route.current = lastRoute
            un()
          else #we are leaving the DW page, don't hang onto lastRoute
            onDWPage = false

        $location.path path

]
